import React from 'react';
import { Box, Chip, Typography } from '@mui/material';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';

interface AISuggestionsProps {
  onSelect: (val: string) => void;
  suggestions: string[];
}

export default function AISuggestions({ onSelect, suggestions = [] }: AISuggestionsProps) {
  return (
    <Box sx={{ width: '100%', mt: 1, display: 'flex', flexDirection: 'column', gap: 3 }}>
      {/* Dynamic suggestions header */}
      {suggestions.length > 0 && (
        <Box>
          <Typography
            variant="subtitle2"
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: 1,
              color: 'text.light',
              fontWeight: 600,
              mb: 1.5,
            }}
          >
            <HelpOutlineIcon fontSize="small" sx={{ color: 'primary.main' }} />
            Suggested queries:
          </Typography>
          <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
            {suggestions.map(suggestion => (
              <Chip
                key={suggestion}
                label={suggestion}
                onClick={() => onSelect(suggestion)}
                sx={{
                  backgroundColor: 'background.paper',
                  border: '1px solid',
                  borderColor: 'primary.light',
                  color: 'primary.main',
                  fontWeight: 600,
                  fontSize: '13px',
                  cursor: 'pointer',
                  transition: 'all 0.2s ease',
                  '&:hover': {
                    backgroundColor: 'primary.main',
                    borderColor: 'primary.main',
                    color: 'primary.contrastText',
                    transform: 'translateY(-1px)',
                    boxShadow: '0 2px 4px rgba(0, 0, 0, 0.08)',
                  },
                  '&:active': {
                    transform: 'translateY(0)',
                  },
                }}
              />
            ))}
          </Box>
        </Box>
      )}
    </Box>
  );
}
